<template>
  <div>
    <!-- BEGIN #footer -->
    <div id="footer" class="footer">
      <!-- BEGIN container -->
      <div class="container">
        <!-- BEGIN row -->
        <div class="row">
          <!-- BEGIN col-3 -->
          <div class="col-md-6">
            <h4 class="footer-header">ABOUT US</h4>
            <p>
              We are democratizing the medical imaging applications market. We provide a new way for distributing, monetizing and evaluating medical imaging solutions. We believe in a worldwide community of users and developers of medical imaging applications that will create improve patient care and empower independent app developers
            </p>
          </div>
          <!-- END col-3 -->
          <!-- BEGIN col-3 -->
          <div class="col-md-3">
            <h4 class="footer-header">RELATED LINKS</h4>
            <ul class="fa-ul">
              <li><i class="fa fa-li fa-angle-right"></i> <a href="/beta/about-us">About Us</a></li>
              <li><i class="fa fa-li fa-angle-right"></i> <a href="/beta/tech">Product</a></li>
              <li><i class="fa fa-li fa-angle-right"></i> <a href="/beta/apps-user">Apps User</a></li>
              <li><i class="fa fa-li fa-angle-right"></i> <a href="/beta/apps-developer">Apps Developer</a></li>
              <li><i class="fa fa-li fa-angle-right"></i> <a href="/beta/contact-us">Contact Us</a></li>
            </ul>
          </div>
          <!-- END col-3 -->
          <!-- BEGIN col-3 -->
          <div class="col-md-3">
            <h4 class="footer-header">OUR CONTACT</h4>
            <address>
              <strong>womia</strong>.play
              <br>
              <abbr title="Email">Email:</abbr> <a href="mailto:hello@womia.io">hello@womia.io</a>
            </address>
          </div>
          <!-- END col-3 -->
        </div>
        <!-- END row -->
      </div>
      <!-- END container -->
    </div>
    <!-- END #footer -->
    <!-- BEGIN #footer-copyright -->
    <div id="footer-copyright" class="footer-copyright">
      <!-- BEGIN container -->
      <div class="container">
        <div class="copyright">
          Copyright &copy; 2023 womia.io. All rights reserved.
        </div>
      </div>
      <!-- END container -->
    </div>
    <!-- END #footer-copyright -->
  </div>
</template>
<script>
export default {
  name: 'FooterBrand'
}
</script>



// WEBPACK FOOTER //
// src/components/FooterBrand.vue